import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { HelpTicket } from '@shared/models/help-ticket.model';

@Component({
  selector: 'miq-ticket-detail-header',
  templateUrl: './ticket-detail-header.component.html',
  styleUrls: ['./ticket-detail-header.component.scss'],
  standalone: false,
})
export class TicketDetailHeaderComponent implements OnChanges, AfterViewInit, OnInit, OnDestroy {
  @Input() public ticketDetail: HelpTicket;
  @Output() public backToListEvent = new EventEmitter<number>();

  public assignedUsers: string[];

  ngOnInit() {
    /** label translation purpose added */
  }
  ngOnDestroy() {
    /** label translation purpose added */
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticketDetail) {
      this.assignedUsers = this.ticketDetail.assignedTo.map(user => user.value);
    }
  }

  ngAfterViewInit() {
    this.assignedUsers = this.ticketDetail.assignedTo.map(user => user.value);
  }

  backToList() {
    this.backToListEvent.emit(0);
  }

  public getAssignedToNames() {
    const { assignedTo } = this.ticketDetail;
    // tslint:disable-next-line:max-line-length
    if (assignedTo.length > 1) {
      return `${assignedTo[0].value} +${assignedTo.length - 1}`;
    }
    return assignedTo[0] && assignedTo[0].value ? assignedTo[0].value : '';
  }
}
